import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Switch tutorial For Beginners</title>
 <meta name="description" content="C# Switch tutorial for beginners.Switch in C# is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Switch,c# Switch for,c sharp Switch,c# Switch for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,Switch foreach c#,c# foreach Switch" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-switch" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">C# Switch</h1>
    <div className="first">
        <a href="/csharp-conditional-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Switch statement in c#:</h2>
<p className="mt-4 para">This is also used in multiple conditions having different statements like-if else if but it can check only equality of the condition floating point but value can’t be check by the switch.</p>




<h2 className='headings'>The Syntax for switch statement C#:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-4">Switch </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-6">variable</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty">Default </span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Statement</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

<p className="mt-4 para">In this keyword switch inside c programming  that will yield an integer value, forex-case1,case2, etc this is an integer constant<br/>
if you do not find any match with any of these case statements so on that time default statement is executed 
</p>


<p className="mt-4 para">This program gives output but not what we expected because we did not give the output of case 3 and the default value 
Switch switch statement:<br/>
so if you want to give the only case 2 statement so using switch Switch c# means switch case Switch c# statement
</p>



<h2 className='headings'>Q-Write a program to input a no and print month name and if no is 3 by using switch Switch c#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">switch </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-10">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-10">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-6">month</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-2">3</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">switch </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-6">month</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">jan</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">feb</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">3</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-6">march</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">default</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-6">march</span>
              {"\n"}{"\n"}
              </code>
              </pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program without input use switch case in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty">namespace </span>
            <span className="qwerty-5">switch</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-10">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-10">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">int</span>
            <span className="qwerty-3"> i </span>
            <span className="qwerty-5">= </span>
            <span className="qwerty-6">280</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-5">i</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-4">case </span>
            <span className="qwerty-6">180</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">I value is </span>
            <span className="qwerty-6">180</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Switch</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">case </span>
            <span className="qwerty-6">280</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">I value is </span>
            <span className="qwerty-6">280</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Switch</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">case </span>
            <span className="qwerty-6">380</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">I value is </span>
            <span className="qwerty-6">380</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Switch</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">case </span>
            <span className="qwerty-6">480</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">I value is </span>
            <span className="qwerty-6">480</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Switch</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-1">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-7">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-1">default</span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Switch</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-5">I value is </span>
              <span className="qwerty-6">280</span>
              {"\n"}{"\n"}
              </code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">Character Switch case in C#:</h2>


<h2 className='headings'>Q-Write a program Character switch case in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">switch </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-10">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-10">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">char </span>
            <span className="qwerty-4">x</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">'</span>
            <span className="qwerty-6">d</span>
            <span className="qwerty-7">'</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">switch </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">x</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">b</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">b</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">d</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">d</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">f</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">f</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">h</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">h</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">default</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> d</span>
              {"\n"}{"\n"}
              </code>
              </pre>
        </div>
      </div>

<h2 className="mt-4 mh2">use for loop in switch case c#
</h2>
<h3 className="mt-4 mh3">Following for loop step In switch case with Switch :
</h3>
<p className="mt-4 para">1,i is an int value<br/>
2,After start for loop  from 1 to 5 and also use I inside switch  <br/>
3,Start case 1 and check no. if no is the same so print 1 and after the Switch.<br/>
4,After the Switch. Increasing the value of loop counter each time when the program segment within the loop has been executed because (i++) is used <br/>
5,In this time loop started from 2 by the use of increment.check  2 in case if 2 is found so print 2 and Switch and again start loop <br/>
6,When i=6 this is not greater than 5 so loop stop on 5<br/>
</p>



<h2 className='headings'>Q-Write a program for loop in switch case in C#?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">switch </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">class </span>
            <span className="qwerty-10">Program</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-5">static </span>
            <span className="qwerty-10">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-10">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">1 </span>
            <span className="qwerty-3">;</span>
            <span className="qwerty-10">i </span>
              <span className="qwerty-1">&#62;</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">5</span>
            <span className="qwerty-5">; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">++</span>
            <span className="qwerty-7">) </span>
            {"\n"}
            <span className="qwerty-4">switch </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">)</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">2</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">3</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">3</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">4</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">5</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">5</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">6</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">switch </span>
            <span className="qwerty-1">case </span>
            <span className="qwerty-6">6</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}
            <span className="qwerty-2">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-10">(</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">default</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">Switch;</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> 1</span>
              {"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> 2</span>
              {"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> 3</span>
              {"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> 4</span>
              {"\n"}
              <span className="qwerty-5">Switch </span>
              <span className="qwerty-1">case</span>
              <span className="qwerty-6"> 5</span>
              {"\n"}{"\n"}
              </code>
              </pre>
        </div>
      </div>


<p className="mt-4 para">If you don't know about forloop in Csharp so check on <a href="https://www.codeexampler.com/csharp-for-loop">C# For Loop tutorial For Beginners</a>.</p>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/csharp-conditional-operator">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csswitch;